<template>
  <!-- One selectable brand in the brand picker grid (radio-style) -->
  <button
    type="button"
    class="brand-card group relative flex items-center gap-3 pl-3 pr-2.5 py-2.5 rounded-lg border text-left focus:outline-none"
    :class="selected
      ? 'border-primary-red-100 bg-primary-red-10 ring-1 ring-primary-red-100'
      : 'border-border-normal bg-white hover:border-border-hover hover:bg-neutral-10'"
    @click="$emit('select', brand)"
  >
    <div class="flex-shrink-0 w-8 h-8 rounded-full bg-neutral-25 ring-1 ring-border-normal overflow-hidden">
      <img
        v-if="!avatarFailed"
        :src="brand.avatar"
        class="w-full h-full object-cover"
        @error="avatarFailed = true"
      >
    </div>
    <div class="min-w-0 flex-1">
      <BaseText
        type="label"
        size="sm"
        class="truncate"
        :class="selected ? 'text-text-loud' : 'text-text-muted'"
      >
        {{ brand.name }}
      </BaseText>
      <BaseText
        type="body"
        size="xs"
        class="text-text-subdued truncate"
      >
        {{ brand.trackedBy.toLocaleString() }} {{ brand.trackedBy === 1 ? 'team' : 'teams' }} tracking
      </BaseText>
    </div>
    <div
      class="brand-radio flex-shrink-0 rounded-full flex items-center justify-center"
      :class="selected
        ? 'bg-primary-red-100'
        : 'border border-border-hover bg-white group-hover:border-neutral-200'"
    >
      <CheckmarkIcon
        v-if="selected"
        :width="14"
        :height="14"
        class-name="text-white"
      />
    </div>
  </button>
</template>

<script>
import CheckmarkIcon from '../globals/Icons/CheckmarkIcon.vue'

export default {
  name: 'SetupBrandCard',
  components: { CheckmarkIcon },
  props: {
    // { name, brandId, pageId, avatar, trackedBy } from curatedBrands.js
    brand: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { avatarFailed: false }
  }
}
</script>

<style scoped>
.brand-card,
.brand-radio {
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease;
}
.brand-radio {
  width: 18px;
  height: 18px;
}
</style>
